import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from '@/components/admin/Dashboard';
import AppNotFound from '@/common/layout/pages/AppNotFound';
import AppForbidden from '@/common/layout/pages/AppForbidden';
import AppError from '@/common/layout/pages/AppError';

// System
import Login from '@/components/admin/auth/Login';
import LoginCiudadania from '@/components/admin/auth/LoginCiudadania';
import LoginNit from '@/components/admin/auth/LoginNit';
import Account from '@/components/admin/account/Account';
import Entidad from '@/components/admin/entidad/Entidad';
import Usuario from '@/components/admin/usuario/Usuario';
import Aplicacion from '@/components/admin/aplicacion/Aplicacion';
import Modulo from '@/components/admin/modulo/Modulo';
import Preferencias from '@/components/admin/preferencias/Preferencias';
import Log from '@/components/admin/Log';

// casos
import Registro from '@/components/casos/registro/Registro';
import Orientaciones from '@/components/casos/orientaciones/Orientacion';
import Conciliacion from '@/components/casos/conciliaciones/Conciliacion';
import Patrocinio from '@/components/casos/patrocinios/Patrocinio';

import Psicologia from '@/components/casos/psicologia/Psicologia';
import TrabajoSocial from '@/components/casos/trabajo-social/TrabajoSocial';

// Reportes
import EdadGenero from '@/components/reportes/EdadGenero';
import EdadMateria from '@/components/reportes/EdadMateria';
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/login-ciudadania',
      name: 'LoginCiudadania',
      component: LoginCiudadania
    },
    {
      path: '/login-nit',
      name: 'LoginNit',
      component: LoginNit
    },
    {
      path: '/usuarios',
      name: 'Usuario',
      component: Usuario
    },
    {
      path: '/aplicaciones',
      name: 'Aplicacion',
      component: Aplicacion
    },
    {
      path: '/account',
      name: 'Account',
      component: Account
    },
    {
      path: '/entidades',
      name: 'Entidad',
      component: Entidad
    },
    {
      path: '/parametros',
      name: 'Preferencias',
      component: Preferencias
    },
    {
      path: '/modulos',
      name: 'Módulo',
      component: Modulo
    },
    {
      path: '/logs',
      name: 'Logs',
      component: Log
    },
    {
      path: '/404',
      component: AppNotFound
    },
    {
      path: '/403',
      component: AppForbidden
    },
    {
      path: '/500',
      component: AppError
    },
    {
      path: '*',
      component: AppNotFound
    },
    {
      path: '/registro-casos',
      name: 'registro',
      component: Registro
    },
    {
      path: '/orientaciones',
      name: 'orientacion',
      component: Orientaciones
    },
    {
      path: '/conciliaciones',
      name: 'conciliacion',
      component: Conciliacion
    },
    {
      path: '/patrocinios-legales',
      name: 'patrocinio',
      component: Patrocinio
    },
    {
      path: '/psicologia',
      name: 'psicologia',
      component: Psicologia
    },
    {
      path: '/trabajo-social',
      name: 'trabajo-social',
      component: TrabajoSocial
    },
    // {
    //   path: '/reportes',
    //   name: 'reporte',
    //   component: Reporte
    // }
    {
      path: '/edad-genero',
      name: 'edad-genero',
      component: EdadGenero
    },
    {
      path: '/edad-materia',
      name: 'edad-materia',
      component: EdadMateria
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js